import { styled } from '@mui/material/styles';
// @mui
import { Box, Button, Container, Typography } from '@mui/material';
// components
import AuthNavbar from 'src/components/AuthNavbar';
import RouterLink from 'src/components/RouterLink';
import Page from '../components/Page';
// illustrations
import StepComplete from 'src/assets/illustration_step_complete';
// hooks
import useCurrentUser from 'src/hooks/core-api/useCurrentUser';
//
import { Navigate } from 'react-location';

// ----------------------------------------------------------------------

const RootStyle = styled('div')(({ theme }) => ({
  display: 'flex',
  height: '100%',
  alignItems: 'center',
  paddingTop: theme.spacing(15),
  paddingBottom: theme.spacing(10),
}));

// ----------------------------------------------------------------------

export default function AwaitingInstallationPage() {
  const currentUserQuery = useCurrentUser();

  // Page guard
  if (currentUserQuery?.data?.onboarding_status !== 'awaiting_first_installation') {
    return <Navigate to="/" />;
  }

  return (
    <>
      <AuthNavbar />
      <Page title="Waiting for installation" sx={{ height: 1 }}>
        <RootStyle>
          <Container>
            <Box sx={{ maxWidth: 600, margin: 'auto', textAlign: 'center' }}>
              <Typography variant="h3" paragraph>
                Payment Information Collected
              </Typography>
              <StepComplete sx={{ height: 200, mr: 5, mt: { xs: 5, sm: 7 } }} />
              <Typography sx={{ mt: 5, mb: { xs: 2.5, sm: 5 }, color: 'text.secondary' }}>
                After installation, you will be able to access your account and begin using your
                personal Lovage Dashboard.
              </Typography>

              <Button to="/" size="large" variant="contained" component={RouterLink}>
                Refresh installation status
              </Button>
            </Box>
          </Container>
        </RootStyle>
      </Page>
    </>
  );
}
